import type { CalendarSyncStatus } from '@core/dashboard-types';
import { createSingleEntityStore } from '@core/ngrx-legacy';

export const {
  actions: CalendarSyncStatusActions,
  reducer: CalendarSyncStatusReducer,
  selectors: CalendarSyncStatusSelectors,
  namespace: CalendarSyncStatusNamespace,
} = createSingleEntityStore<CalendarSyncStatus>()('CalendarSyncStatus');
